/** Stable drag id for quote line items (persisted `_id` or ephemeral `__dragId`). */
export const quoteItemDragId = (item: { _id?: string; __dragId?: string }, index: number) => (
    String(item._id || item.__dragId || `item-${index}`)
);

export const newQuoteItemDragId = () => (
    `new-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
);

/** Reorder a list by moving index `from` to `to` (immutable). */
export const moveQuoteItem = <T,>(items: T[], from: number, to: number): T[] => {
    if (from === to || from < 0 || to < 0 || from >= items.length || to >= items.length)
        return items;
    const next = Array.from(items);
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    return next;
};
